import { Component, ViewChild } from '@angular/core';
import { OrganisationUnitService } from '../../../services/organisation-unit.service';
import { forkJoin } from 'rxjs';
import { OrganisationUnitModel } from '../../../models/organisation-unit/organisation-unit.model';
import { first, map, shareReplay } from 'rxjs/operators';
import { TrainingGroupModel } from '../../../models/training-group.model';
import { TimeZoneModel } from '../../../models/time-zone.model';
import { RoleModel } from '../../../models/person/role.model';
import { PersonService } from '../../../services/person.service';
import { UserService } from '../../../services/user.service';
import { TrainingGroupService } from '../../../services/training-group.service';
import { TimeZoneService } from '../../../services/time-zone.service';
import { RoleService } from '../../../services/role.service';
import { PersonCreationAndUpdateModel } from '../../../models/person/person-creation-and-update.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonFullModel } from '../../../models/person/person-full.model';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../services/loading.service';
import { CompletedEventService } from '../../../services/completed-event.service';
import { CompletedEventSummaryModel } from '../../../models/completed-event/completed-event-summary.model';
import { UserModel } from 'src/app/models/person/user.model';
import { ManageUserModel } from 'src/app/models/person/manage-user.model';
import { DxSelectBoxTypes } from 'devextreme-angular/ui/select-box';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { AuthorizationService } from '../../../services/authorization.service';
import { FileUtilService } from '../../../services/file-util.service';
import { ConfirmationDialogData } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '../../../services/time.service';
import validationEngine from 'devextreme/ui/validation_engine';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { HttpErrorResponse } from '@angular/common/http';
import { LearningPathModel } from 'src/app/models/learning-paths/learning-path.model';
import { LearningPathService } from 'src/app/services/learning-path.service';
import { GeneralSettingsService } from 'src/app/services/general-settings.service';
import { ApprovalRequestService } from 'src/app/services/approval-request.service';
import { ApprovalRequestExternalCertificateSummaryModel } from 'src/app/models/approval-request/approval-request-external-certificate-summary.model';
import { TrainingService } from 'src/app/services/training.service';
import { CourseTemplateService } from 'src/app/services/course-template.service';
import { TrainingSummaryModel } from 'src/app/models/training/training-summary.model';
import { CourseTemplateSummaryModel } from 'src/app/models/course/course-template-summary.model';
import { ROLE_NAMES } from 'src/app/constants/role.constants';
import { BrokerAccessService } from 'src/app/services/brokers/broker-access.service';
import { PageStateService } from 'src/app/services/page-state.service';
import { PageStateFlags } from 'src/app/constants/page-state.constants';
import { TenantSubscriptionService } from 'src/app/services/tenants/tenant-subscription.service';
import { TenantContextService } from 'src/app/services/tenant-context.service';
import { CompletedEventCategoryModel } from 'src/app/models/completed-event/completed-event-category.model';

interface PersonCompetencyMatrixPoint extends CompletedEventCategoryModel {
  categoryKey: string;
}

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.scss'],
  standalone: false
})
export class EmployeeFormComponent {
  @ViewChild('topForm', { static: true }) topForm!: DxFormComponent;
  @ViewChild('bottomForm', { static: true }) bottomForm!: DxFormComponent;
  @ViewChild(DxDropDownBoxComponent, { static: false })
  locationDropDown!: DxDropDownBoxComponent;
  @ViewChild(DxDropDownBoxComponent, { static: false })
  departmentDropDown!: DxDropDownBoxComponent;

  editingPersonId!: string;
  editingPerson: PersonFullModel | null = null;
  
  isOverviewPopupVisible: boolean = false;
  isProfilePage: boolean = false;
  isManager: boolean = true;
  isSuperAdmin: boolean = true;
  isBroker: boolean = true;
  isInactive: boolean = false;
  isCurrentUser: boolean = false;
  isUserHasAccount: boolean = false;
  canSendBrokerAccess: boolean = false;
  selectedTab: number = 0;
  tabs: any[] = [
    {
      id: 0,
      text: this.translateService.instant('EMPLOYEE.FORM.PROFILE-TAB'),
    },
    {
      id: 1,
      text: this.translateService.instant('EMPLOYEE.FORM.TRAININGS-TAB'),
    },
  ];
  organizationUnits!: OrganisationUnitModel[];
  locations!: OrganisationUnitModel[];
  trainingGroups!: TrainingGroupModel[];
  learningPaths!: LearningPathModel[];
  timeZones!: TimeZoneModel[];
  roles!: RoleModel[];
  completedEvents!: CompletedEventSummaryModel[];
  externalRequests!: ApprovalRequestExternalCertificateSummaryModel[];
  openTrainings!: TrainingSummaryModel[];
  openCourses!: CourseTemplateSummaryModel[];

  employeeForm: PersonCreationAndUpdateModel = {
    firstName: null,
    lastName: null,
    locationId: null,
    trainingGroupIds: [],
    learningPathIds: [],
    city: null,
    culture: null,
    email: null,
    iddNumber: null,
    agentNumber: null,
    phoneBusiness: null,
    phoneMobile: null,
    phonePrivate: null,
    roleId: null,
    timeZone: null,
    street: null,
    zipCode: null,
    imageBase64: null,
    emailSignature: null,
    companyName: null
  };

  isExternalCertificateApprovalEnabled: boolean = false;
  isTenantPublishedToSubscribers: boolean = false;
  isBrokerPoolTenant: boolean = false;

  public iddHoursReachedString: string = '00:00';

  rolesOptions!: DxSelectBoxTypes.Properties;
  timeZonesOptions!: DxSelectBoxTypes.Properties;
  languagesOptions!: DxSelectBoxTypes.Properties;

  modalOptions: ConfirmationDialogData | null = null;
  showModal = false;
  currentModalID: 'addUser' | 'changePassword' | null = null;

  showPublishingModeRequiredModal: boolean = false;

  isPersonCompetencyMatrixLoaded: boolean = false;
  personCompetencyMatrixData: PersonCompetencyMatrixPoint[] = [];
  allCategoryKeys: string[] = [];

  private categoryNameByKey = new Map<string, string>();

  readonly maxCategoryLabelLength: number = 10;
  readonly maxCategoriesForPolarChart: number = 20;
  readonly maxCategoriesForInclineLabels: number = 25;

  get isEditingPersonBroker(): boolean {
    if(!this.editingPerson) return false;

    return this.editingPerson.person.role.name === ROLE_NAMES.Broker;
  }

  get canSendAccessData(): boolean {
    return (
      !this.isUserHasAccount &&
      !this.isInactive &&
      (!this.isEditingPersonBroker || this.canSendBrokerAccess)
    );
  }

  get canResetPassword(): boolean {
    return (
      this.isUserHasAccount &&
      !this.isInactive &&
      this.isManager &&
      (!this.isEditingPersonBroker || this.isBrokerPoolTenant)
    );
  }

  constructor(
    private organisationUnitService: OrganisationUnitService,
    private personService: PersonService,
    private trainingGroupService: TrainingGroupService,
    private learningPathService: LearningPathService,
    private timeZoneService: TimeZoneService,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private loadingService: LoadingService,
    private completedEventService: CompletedEventService,
    private userService: UserService,
    private authorizationService: AuthorizationService,
    private fileUtilService: FileUtilService,
    private translateService: TranslateService,
    private settingsService: GeneralSettingsService,
    private approvalRequestService: ApprovalRequestService,
    private trainingService: TrainingService,
    private courseTemplateService: CourseTemplateService,
    private brokerAccessService: BrokerAccessService,
    private pageStateService: PageStateService,
    private tenantSubscriptionService: TenantSubscriptionService,
    private tenantContext: TenantContextService
  ) {
    const tab: string | null = this.route.snapshot.queryParams['tab'];

    if (tab && tab === 'trainings') {
      this.selectedTab = 1;
    }

    this.isBrokerPoolTenant = this.tenantContext.isBrokerPoolTenant();

    const formData = this.loadingService
      .load(
        forkJoin({
          organizationUnits:
            this.organisationUnitService.getAllOrganisationUnits(),
          trainingGroups: this.trainingGroupService.getAllTrainingGroups(),
          learningPaths: this.learningPathService.getAllLearningPaths()
            .pipe(map((learningPaths) => learningPaths.map((learningPath) => ({ ...learningPath, selected: false })))),
          timeZones: this.timeZoneService.getAllTimeZones(),
          roles: this.roleService.getAllRoles(),
          isExternalCertificateApprovalEnabled: this.settingsService.isExternalCertificateApprovalEnabled(),
          isTenantPublishedToSubscribers: this.tenantSubscriptionService.isPublishedToSubscribers(),
        })
      )
      .pipe(shareReplay(1));

    formData.subscribe(
      ({ 
        organizationUnits, trainingGroups, learningPaths, timeZones, roles, 
        isExternalCertificateApprovalEnabled, isTenantPublishedToSubscribers
      }) => {
        this.organizationUnits = organizationUnits;
        this.locations = organizationUnits;
        this.trainingGroups = trainingGroups;
        this.learningPaths = learningPaths;
        this.timeZones = timeZones;
        this.isExternalCertificateApprovalEnabled = isExternalCertificateApprovalEnabled;
        this.isTenantPublishedToSubscribers = isTenantPublishedToSubscribers;

        this.roles = roles;
        this.roles.forEach((role) => {
          if (role.name == 'Employee') {
            role.name = this.translateService.instant('COMMON.EMPLOYEE');
          }
          if (role.name == 'Broker') {
            role.name = this.translateService.instant('COMMON.BROKER');
          }
        });

        this.editingPersonId = this.route.snapshot.params['id'];
        const path = this.route.snapshot.routeConfig!.path!;
        if (path.includes('profile')) {
          this.isProfilePage = true;
        }

        if (!this.editingPersonId && !this.isProfilePage) {
          this.setDropdownOptions();
        }

        if (this.editingPersonId || this.isProfilePage) {
          this.authorizationService
            .getCurrentPerson()
            .pipe(first())
            .subscribe((currentUser) => {
              if (this.isProfilePage) {
                this.editingPersonId = currentUser.person.id;
              }

              if (
                currentUser.person.role.name !== ROLE_NAMES.Manager &&
                currentUser.person.role.name !== ROLE_NAMES.SuperAdmin
              ) {
                this.isManager = false;
              }

              if (currentUser.person.role.name !== ROLE_NAMES.SuperAdmin) {
                this.isSuperAdmin = false;
                this.roles = this.roles.filter(
                  (role) => role.name !== ROLE_NAMES.SuperAdmin
                );
              }

              if (currentUser.person.role.name !== ROLE_NAMES.Broker) {
                this.isBroker = false;
              }

              this.setDropdownOptions();

              const personData = this.loadingService
                .load(
                  forkJoin({
                    person: this.personService.getPerson(this.editingPersonId),
                    canSendBrokerAccess: this.brokerAccessService.canSendBrokerAccess(this.editingPersonId),
                    iddTimeMinutes: this.personService.getPersonIddTimeMinutes(
                      this.editingPersonId
                    ),
                    completedEvents:
                      this.completedEventService.getAllCompletedEvents(
                        this.editingPersonId
                      ),
                    externalRequests:
                      this.approvalRequestService.getApprovalRequestExternalCertificates(
                        this.editingPersonId
                      ),
                    openTrainings:
                      this.trainingService.getAcceptedAndOpenTrainings(
                        this.editingPersonId
                      ),
                    openCourses:
                      this.courseTemplateService.getOpenCourseTemplates(
                        this.editingPersonId
                      ),
                  })
                )
                .pipe(shareReplay(1));

              personData.subscribe(
                ({ 
                  person, canSendBrokerAccess, completedEvents, iddTimeMinutes, 
                  externalRequests, openTrainings, openCourses 
                }) => {
                  this.editingPerson = person;
                  this.canSendBrokerAccess = canSendBrokerAccess;
                  this.patchForm(person);
                  this.completedEvents = this.sortEventsByDate(completedEvents);
                  this.externalRequests = this.sortCertificatesByDate(externalRequests);
                  this.openTrainings = openTrainings;
                  this.openCourses = openCourses;

                  this.iddHoursReachedString =
                    TimeService.getHoursAndMinutesDisplayStringFromIddTimeMinutes(
                      iddTimeMinutes
                    );
                  if (currentUser.person.id === person.person.id) {
                    this.isCurrentUser = true;
                    this.tabs.push({
                      id: 2,
                      text: this.translateService.instant(
                        'EMPLOYEE.FORM.EMAIL-SIGNATURE-TAB'
                      ),
                    });
                  }

                  if (person.user) {
                    this.patchFormUser(person.user);
                  }
                }
              );
            });
        }

        if (this.editingPersonId) {
          this.loadingService
            .load(
              this.personService.getEventCompletedCategoriesByPersonId(
                this.editingPersonId
              )
            )
            .subscribe((data) => {
              this.isPersonCompetencyMatrixLoaded = true;

              this.personCompetencyMatrixData = data.map((x, i) => ({
                ...x,
                categoryKey: `c${i}`
              }));

              this.allCategoryKeys = this.personCompetencyMatrixData.map(
                x => x.categoryKey
              );

              this.categoryNameByKey = new Map(
                this.personCompetencyMatrixData.map(x => [
                  x.categoryKey,
                  x.categoryName
                ])
              );
            });
        }
      }
    );
  }

  private getCategoryName(key: string): string {
    return this.categoryNameByKey.get(key) ?? key;
  }

  sortEventsByDate(
    events: CompletedEventSummaryModel[]
  ): CompletedEventSummaryModel[] {
    return events.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      if (dateA > dateB) {
        return -1;
      }
      if (dateA < dateB) {
        return 1;
      }
      return 0;
    });
  }

  sortCertificatesByDate(
    certificates: ApprovalRequestExternalCertificateSummaryModel[]
  ): ApprovalRequestExternalCertificateSummaryModel[] {
    return certificates.sort((a, b) => {
      const dateA = new Date(a.eventDate);
      const dateB = new Date(b.eventDate);

      if (dateA > dateB) {
        return -1;
      }
      if (dateA < dateB) {
        return 1;
      }
      return 0;
    });
  }

  navigateBack(): void {
    this.pageStateService.setFlag(
      PageStateFlags.RestoreEmployeesOverview
    );
    
    this.router.navigate(['employee']);
  }

  nullifyEmptyFields(obj: any) {
    Object.keys(obj).forEach((key: string) => {
      if (!obj[key]) {
        obj[key] = null;
      }
    });
  }

  onFormSubmit(): void {
    const isTopFormValid = this.topForm.instance.validate().isValid;
    const isBottomFormValid = this.bottomForm.instance.validate().isValid;
    const isCustomFieldsValid =
      validationEngine.validateGroup('customFields').isValid;

    if (isTopFormValid && isBottomFormValid && isCustomFieldsValid) {
      if (!this.editingPersonId) {
        const employee = {
          ...this.employeeForm,
          imageBase64: this.employeeForm.imageBase64
            ? this.employeeForm.imageBase64!.split(',')[1]
            : null,
        };
        this.nullifyEmptyFields(employee);

        const result = this.personService.addPerson(employee);
        this.loadingService.load(result).subscribe({
          next: (createdPerson) => {
            this.toastrService.success(
              this.translateService.instant('EMPLOYEE.FORM.EMPLOYEE-CREATED')
            );
            this.router.navigate([
              'employee', 'edit', createdPerson.person.id
            ]);
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 409 && err.error == 'duplicate-email') {
              this.toastrService.warning(
                this.translateService.instant(
                  'EMPLOYEE.FORM.DUPLICATE-EMAIL-ERROR'
                )
              );
            } else {
              this.toastrService.error(
                this.translateService.instant('COMMON.AN-ERROR-HAS-OCCURRED')
              );
            }
          },
        });
      } else {
        const employee: any = {
          ...this.employeeForm,
          imageBase64: this.employeeForm.imageBase64
            ? this.employeeForm.imageBase64!.split(',')[1]
            : null,
        };
        this.nullifyEmptyFields(employee);

        if (!employee.imageBase64) {
          delete employee.imageBase64;
        }

        const result = this.personService.updatePerson(
          this.editingPersonId,
          employee
        );
        this.loadingService.load(result).subscribe({
          next: (updatedPerson) => {
            this.toastrService.success(
              this.translateService.instant('EMPLOYEE.FORM.EMPLOYEE-UPDATED')
            );
            window.location.reload();
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 409 && err.error == 'duplicate-email') {
              this.toastrService.warning(
                this.translateService.instant(
                  'EMPLOYEE.FORM.DUPLICATE-EMAIL-ERROR'
                )
              );
            } else {
              this.toastrService.error(
                this.translateService.instant('COMMON.AN-ERROR-HAS-OCCURRED')
              );
            }
          },
        });
      }
    }
  }

  setDropdownOptions() {
    const defaultSelectOptions = {
      showClearButton: true,
      stylingMode: 'outlined',
      displayExpr: 'name',
      valueExpr: 'id',
    } as DxSelectBoxTypes.Properties;

    this.rolesOptions = {
      ...defaultSelectOptions,
      dataSource: this.roles,
      placeholder: '',
      disabled: !this.isSuperAdmin,
    };
    this.timeZonesOptions = {
      ...defaultSelectOptions,
      dataSource: this.timeZones,
      placeholder: '',
    };
    this.languagesOptions = {
      ...defaultSelectOptions,
      dataSource: [
        { id: 'en', name: 'English' },
        { id: 'de', name: 'Deutsch' },
        { id: 'es', name: 'Español' },
        { id: 'fr', name: 'Français' },
        { id: 'it', name: 'Italiano' },
        { id: 'nl', name: 'Nederlands' },
        { id: 'pl', name: 'Polski' },
      ],
      placeholder: '',
    };

    if (!this.editingPersonId && !this.isProfilePage) {
      this.employeeForm.culture = 'de';
      this.employeeForm.timeZone = 'W. Europe Standard Time';
    }
  }

  onLocationSelected(e: any) {
    if (e.node.key) {
      this.employeeForm.locationId = e.node.key;
    }
  }

  onTrainingGroupSelected(e: any) {
    if (e.node.selected) {
      this.employeeForm.trainingGroupIds = [
        ...this.employeeForm.trainingGroupIds,
        e.node.key,
      ];
    } else {
      this.employeeForm.trainingGroupIds =
        this.employeeForm.trainingGroupIds.filter((id) => id !== e.node.key);
    }
  }

  onLearningPathSelected(e: any) {
    if (e.node.selected) {
      this.employeeForm.learningPathIds = [
        ...this.employeeForm.learningPathIds,
        e.node.key,
      ];
    } else {
      this.employeeForm.learningPathIds =
        this.employeeForm.learningPathIds.filter((id) => id !== e.node.key);
    }
  }


  onAvatarUploaded(files: any) {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.employeeForm!.imageBase64 = reader!.result!.toString();
    };
    reader.readAsDataURL(file);
  }

  patchForm(person: PersonFullModel) {
    this.employeeForm.firstName = person.person.firstName;
    this.employeeForm.lastName = person.person.lastName;
    this.employeeForm.locationId = person.person.location.id;
    this.employeeForm.roleId = person.person.role.id;
    this.employeeForm.culture = person.person.culture;
    this.employeeForm.timeZone = person.person.timeZone;
    this.employeeForm.email = person.person.email;
    this.employeeForm.iddNumber = person.person.iddNumber || null;
    this.employeeForm.phonePrivate = person.person.phonePrivate;
    this.employeeForm.phoneMobile = person.person.phoneMobile;
    this.employeeForm.phoneBusiness = person.person.phoneBusiness;
    this.employeeForm.agentNumber = person.person.agentNumber;
    this.employeeForm.emailSignature = person.person.emailSignature;
    this.employeeForm.companyName = person.person.companyName;

    this.employeeForm.city = person.person.city;
    this.employeeForm.street = person.person.street;
    this.employeeForm.zipCode = person.person.zipCode;
    this.employeeForm.trainingGroupIds = person.trainingGroups.map(
      (tg) => tg.id
    );
    this.employeeForm.learningPathIds = person.learningPaths.map(
      (tg) => tg.id
    );
    this.employeeForm.createdAt = person.person.createdAt
      ? new Date(person.person.createdAt)
      : null;
    this.employeeForm.status = person.person.inactive ? 'Inactive' : 'Active';
    this.isInactive = person.person.inactive;

    if (person.user) {
      this.employeeForm.accessGranted = person.user!.createdAt!
        ? new Date(person.user!.createdAt!)
        : null;
    } else {
      this.employeeForm.accessGranted = null;
    }

    const imageUrl = person.person.imageFile?.fileUrl;

    if (imageUrl) {
      this.loadingService
        .load(this.fileUtilService.avatarUrlToBase64(imageUrl))
        .subscribe((base64) => {
          const mimeType = this.fileUtilService.getImageMimeType(imageUrl);
          this.employeeForm.imageBase64 = `data:${mimeType};base64,${base64}`;
        });
    }

    this.setTreeViewValues();
    //this.filterDepartments();
  }

  setTreeViewValues() {
    this.trainingGroups.forEach((trainingGroup) => {
      if (this.employeeForm.trainingGroupIds.indexOf(trainingGroup.id) > -1) {
        trainingGroup.selected = true;
      }
    });

    this.learningPaths.forEach((learningPath) => {
      if (this.employeeForm.learningPathIds.indexOf(learningPath.id) > -1) {
        learningPath.selected = true;
      }
    });
  }

  patchFormUser(user: UserModel) {
    this.isUserHasAccount = user.createdAt != null;
  }

  onTabChange(e: DxTabsTypes.ItemClickEvent) {
    this.selectedTab = e.itemData.id;
  }

  onTabChangeMobile(e: any) {
    this.selectedTab = e.value.id;
  }

  refreshEvents() {
    this.refreshComponent(true);
  }

  togglePersonState(state: string) {
    if (this.editingPersonId) {
      const result = this.personService.togglePersonState(
        this.editingPersonId,
        state
      );
      this.loadingService.load(result).subscribe(() => {
        if (state == 'inactive')
          this.toastrService.success('Employee status was set to inactive!');
        else this.toastrService.success('Employee status was set to active!');

        this.refreshComponent();
      });
    }
  }

  refreshComponent(isLoadTrainings: boolean = false) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      const routeConfig: any = {};

      if (isLoadTrainings) {
        routeConfig.queryParams = { tab: 'trainings' };
      }

      this.router.navigate(
        ['/employee/edit/' + this.editingPersonId],
        routeConfig
      );
    });
  }

  openAddUserConfirmationModal() {
    this.currentModalID = 'addUser';
    this.modalOptions = {
      hideUndo: true,
      submitButtonText: this.translateService.instant('COMMON.YES'),

      message: this.translateService.instant(
        'EMPLOYEE.FORM.CONFIRM-SEND-LOGIN-DETAILS'
      ),
      dismissButtonText: this.translateService.instant('COMMON.NO'),
    };
    this.showModal = true;
  }

  openChangeUserPasswordConfirmationModal() {
    this.currentModalID = 'changePassword';
    this.modalOptions = {
      hideUndo: true,
      submitButtonText: this.translateService.instant('COMMON.YES'),
      message: this.translateService.instant(
        'EMPLOYEE.FORM.CONFIRM-RESET-PASSWORD-FOR-EMPLOYEE'
      ),
      dismissButtonText: this.translateService.instant('COMMON.NO'),
    };
    this.showModal = true;
  }

  navigateToActivityLogs() {
    this.router.navigate(['activity-log'], {
      queryParams: { personId: this.editingPersonId },
    });
  }

  modalSubmit() {
    switch (this.currentModalID) {
      case 'addUser':
        this.addUser();
        return;
      case 'changePassword':
        this.changeUserPassword();
        return;
      default:
        break;
    }

    this.currentModalID = null;
  }

  addUser() {
    if (!this.editingPersonId) return;

    if(
      !this.isTenantPublishedToSubscribers && 
      this.isEditingPersonBroker
    ) {
      this.showPublishingModeRequiredModal = true;
      return;
    }

    this.provisionUserAccess(this.editingPersonId);
  }

  provisionUserAccess(personId: string) {
    this.loadingService
      .load(this.userService.provisionUserAccess(personId))
      .subscribe(() => {
        this.toastrService.success('Zugangsdaten wurden versendet');
        this.refreshComponent();
      });
  }

  onPublishingModeRequiredModalClosed() {
    this.showModal = false;
  }
  
  changeUserPassword() {
    if (this.editingPersonId) {
      const model: ManageUserModel = {
        personId: this.editingPersonId,
        newPassword: null,
        newEmail: null,
      };

      this.loadingService
        .load(this.userService.changeUserPasswordByPersonId(model))
        .subscribe(() => {
          this.toastrService.success('Kennwort wurde zurückgesetzt');
          this.refreshComponent();
        });
    }
  }

  showOverviewPopup() {
    this.isOverviewPopupVisible = true;
  }

  onOverviewPopupClose() {
    this.isOverviewPopupVisible = false;
  }

  customizeCategoryLabel = (info: any): string => {
    const label = this.getCategoryName(info.value);

    return label.length > this.maxCategoryLabelLength
      ? label.slice(0, this.maxCategoryLabelLength) + '…'
      : label;
  };

  customizeCategoryHint = (info: any): string => {
    return this.getCategoryName(info.value);
  };

  customizeTooltip = (info: any) => ({
    text: `${this.getCategoryName(info.argument)}: ${info.value}`
  });
}
